export default __webpack_public_path__ + "static/sportdog-about-us-press-release-64e9d0699bb01e45954e51d5603e50d6.jpg";